import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {faPlus, faEye, faEdit} from '@fortawesome/free-solid-svg-icons';
import {UserService} from '../../../shared/services/user/user.service';
import {User} from '../../../shared/classes/user/user';
import {FormControl, Validators, FormGroup} from '@angular/forms';
import {StatesService} from '../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {ReferentialService} from '../../../shared/services/referential/referential.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {LevelService} from '../../../shared/services/level/level.service';
import {ModalService} from '../../../shared/services/modal/modal.service';

@Component({
  selector: 'app-user-crud',
  templateUrl: './user-crud.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./user-crud.component.css']
})
export class UserCrudComponent implements OnInit {

  public faPlus = faPlus;
  public faEye = faEye;
  public faEdit = faEdit;
  public showSpinner: boolean;
  @Input() userId = null;
  @Input() mode = null;
  public user: User = new User();
  public readOnly = true;
  public toggleDisabled = false;

  public typesOfRoles: any[] = [];

  public levelsList: any[] = [];


  public userForm = new FormGroup({
    lastname: new FormControl('', [Validators.required, Validators.minLength(2),
      Validators.maxLength(50)]),
    firstname: new FormControl('', [Validators.required, Validators.minLength(2),
      Validators.maxLength(50)]),
    phone: new FormControl('', [Validators.minLength(9), Validators.maxLength(21),
      Validators.pattern('^(\\+)[1-9]\\d+$')]),
    email: new FormControl('', [Validators.required, Validators.email]),
    lang: new FormControl('', [Validators.required, Validators.maxLength(2)]),
    active: new FormControl(true, [Validators.required]),
    level: new FormControl(''),
  });

  public userRoleForm = new FormGroup({
    roles: new FormControl('', [Validators.required])
  });

  public userPassWord = new FormGroup({
    plainPassword: new FormControl('', [Validators.required, Validators.minLength(5),
      Validators.maxLength(50)]),
  });


  constructor(private modalService: ModalService,
              private referentialService: ReferentialService,
              private userService: UserService,
              private levelService: LevelService,
              private toastr: ToastrService,
              public statesService: StatesService,
              public activeModal: NgbActiveModal,
              private translate: TranslateService,
              private authenticationService: AuthenticationService) {
    this.typesOfRoles = this.authenticationService.currentUserCanManageUsers() ?
      this.referentialService.getUserRolesForLevelAdmin() : this.referentialService.getUserRolesForUser();
  }

  ngOnInit() {
    this.readOnly = this.mode === 'read' ? true : false;

  }

  openModal(content) {
    this.activeModal = this.modalService.openNgbModal(content, {size: 'lg'});
    if (this.mode === 'create') {
      this.userForm.value.active = true;
      this.toggleDisabled = true;

    }
    if (this.mode !== 'create') {
      if (this.currentUserCanChangeUserLevel()) {
        this.showSpinner = true;
        this.levelService.getLevels(true).subscribe((data: any) => {
            this.levelsList = data;
            this.showSpinner = false;
            this.getUser();
          },
          error2 => {
            this.showSpinner = false;
          });

      } else {
        this.getUser();
      }
    }

  }

  public get email() {
    return this.userForm.get('email');
  }


  public getErrorMessageEmail(): string {

    return this.email.hasError('required') || this.email.hasError('email') ? this.translate.instant('EMAIL_INVALID') : '';
  }


  public get lastname() {
    return this.userForm.get('lastname');
  }


  public getErrorMessageLastName(): string {

    if (this.lastname.hasError('required')) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.lastname.hasError('minlength')) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.lastname.hasError('maxlength')) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }

    return '';
  }

  public get firstname() {
    return this.userForm.get('firstname');
  }


  public getErrorMessageFirstName(): string {


    if (this.firstname.hasError('required')) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.firstname.hasError('minlength')) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.firstname.hasError('maxlength')) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }

    return '';
  }


  public get phone() {
    return this.userForm.get('phone');
  }


  public getErrorMessagePhone(): string {

    if (this.phone.hasError('minlength')) {
      return this.translate.instant('VALUE_USER_PHONE_TOO_SHORT');
    }

    if (this.phone.hasError('maxlength')) {
      return this.translate.instant('VALUE_USER_PHONE_TOO_LONG');
    }

    if (this.phone.hasError('pattern')) {
      return this.translate.instant('VALUE_USER_PHONE_NOT_INTERNATIONAL');
    }

    return '';
  }


  public get lang() {
    return this.userForm.get('lang');
  }

  public getErrorMessageLang(): string {
    return this.lang.hasError('required') ? this.translate.instant('FORM_VALUE_MANDATORY') : '';
  }

  public get roles() {
    return this.userRoleForm.get('roles');
  }

  public getErrorMessageRoles(): string {
    return this.roles.hasError('required') ? this.translate.instant('FORM_VALUE_MANDATORY') : '';
  }

  public get plainPassword() {
    return this.userPassWord.get('plainPassword');
  }

  public getErrorMessagePlainPassword() {
    return this.plainPassword.hasError('required') ? this.translate.instant('VALUE_FORM_REQUIRED') : '';
  }


  public closeModal() {
    if (this.mode === 'create') {
      this.userId = null;
    }
    this.user = new User();
    setTimeout(() => {
      this.userForm.reset({active: true});
      this.userRoleForm.reset();
    }, 0);
    this.activeModal.close();

  }

  public userHasChanged(): boolean {
    let changes = 0;
    changes = this.user.lastname !== this.userForm.value.lastname ? changes + 1 : changes;
    changes = this.user.firstname !== this.userForm.value.firstname ? changes + 1 : changes;
    changes = this.user.phone !== this.userForm.value.phone ? changes + 1 : changes;
    changes = this.user.email !== this.userForm.value.email ? changes + 1 : changes;
    changes = this.user.lang !== this.userForm.value.lang ? changes + 1 : changes;
    changes = this.user.active !== this.userForm.value.active ? changes + 1 : changes;
    changes = this.user.level !== this.userForm.value.level ? changes + 1 : changes;

    changes = this.user.roles !== this.userRoleForm.value.roles ? changes + 1 : changes;

    return changes > 0;

  }

  public currentUserCanChangeUserLevel() {

    return (this.authenticationService.currentUserCanManageLevels() && (this.authenticationService.getUserId() !== this.userId));
  }


  public persistUser() {

    if (this.userRoleForm.valid && this.userForm.valid) {

      if (this.userHasChanged()) {
        this.showSpinner = true;

        this.user.lastname = this.userForm.value.lastname;
        this.user.firstname = this.userForm.value.firstname;
        this.user.phone = this.userForm.value.phone;
        this.user.email = this.userForm.value.email;
        this.user.lang = this.userForm.value.lang;
        this.user.active = this.userForm.value.active;
        if (this.currentUserCanChangeUserLevel()) {
          this.user.level = this.userForm.value.level;
        }


        if (this.userId !== null) {

          this.userService.patchUser(this.userId, this.user)
            .subscribe((data: any) => {
                this.setUser(data);
                this.statesService.reloadListUser.next();
                this.toastr.success(this.translate.instant('USER_MODIFIED'), this.translate.instant('SUCCESS'));
                this.closeModal();
              }
              ,
              error2 => {
                this.showSpinner = false;
              });


        } else if (this.userId === null) {

          this.user.level = this.statesService.stateLevel;
          this.user.plainPassword = this.userPassWord.value.plainPassword;
          this.user.active = true;
          this.userService.postUser(this.user)
            .subscribe((data: any) => {
                this.setUser(data);
                this.statesService.reloadListUser.next();
                this.toastr.success(this.translate.instant('USER_CREATED'), this.translate.instant('SUCCESS'));
                this.closeModal();
              },
              error2 => {
                this.showSpinner = false;
              });
        }
      } else {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      }
    }

  }

  private getUser() {
    if (this.userId !== null) {

      this.showSpinner = true;

      this.userService.getUser(this.userId).subscribe((data: any) => {
          this.setUser(data);
        }
        ,
        error2 => {
          this.showSpinner = false;
        });
    }
  }

  private setUser(data) {
    this.user.setUser(data);

    this.userForm.patchValue({
      email: this.user.email,
      lang: this.user.lang,
      lastname: this.user.lastname,
      firstname: this.user.firstname,
      phone: this.user.phone,
      active: this.user.active,
      level: this.user.level,
    });

    this.userRoleForm.patchValue({
      roles: this.user.roles,
    });

    this.user.roles.map(role => {
      this.typesOfRoles.forEach(type => {

        if (type.value === role) {
          type.selected = true;
        }
      });
    });

    this.showSpinner = false;
  }

  public updateRolesIsUser(listRole) {

    this.user.roles = listRole.selectedOptions.selected.map(item => item.value);


  }

  getRoleDisplayed(role: string) {
    let roleToDisplay: string = '';
    this.typesOfRoles.map(t => {
      if (role === t.value) {
        roleToDisplay = t.displayedValue;
      }
    });
    return roleToDisplay;
  }

}
